/*
 * Simple Fencing Panel Configurator
 *
 * Version: v1.2.8-master (Maintained baseline + Master Post SKUs v1.1)
 *
 * This is the active production file (treated as the v1.2.7b lineage).
 * It is designed to work with the consolidated master post products and
 * the approved SKU protocol in _important_notes/sf_sku_protocol-post_sku_v1.1.md.
 *
 * additional_posts data is kept in sync via scripts/patch_configurator_post_skus.py
 */

(function () {
  'use strict';

  const MONEY_FORMATTER = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });

  const DEFAULT_OPTION_IMAGES = {
    picket_caps: {
      'chamfered': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/picket-cap-chamfered.png?v=1779710493',
      'dog ear': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/picket-cap-chamfered.png?v=1779710493',
      'pointed': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/picket-cap-pointed.png?v=1779710493',
    },
    post_caps: {
      'no post cap': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'no post caps': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'no post cap needed': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'no cap': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'no caps': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'none': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-none.png?v=1779710493',
      'external flat': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-external-flat.png?v=1779710493',
      'internal flat': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-internal-flat.png?v=1779710493',
      'gothic': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-gothic.png?v=1779710494',
      'new england': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-cap-new-england.png?v=1779710493',
    },
    post_types: {
      'panel only': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'no post needed': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'no posts needed': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'no post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'no posts': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'none': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-none.png?v=1779710494',
      'end post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-end.png?v=1779710493',
      'end': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-end.png?v=1779710493',
      'line post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-line.png?v=1779710493',
      'line': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-line.png?v=1779710493',
      'corner post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-corner.png?v=1779710493',
      'corner': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-corner.png?v=1779710493',
      't-post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-three-way.png?v=1779710493',
      't post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-three-way.png?v=1779710493',
      't': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-three-way.png?v=1779710493',
      'cross post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'cross': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'x-post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'x post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'cross-post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      '4 way': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      '4-way': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'four way': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-cross.png?v=1780091852',
      'blank post': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-blank.png?v=1779710493',
      'blank': 'https://cdn.shopify.com/s/files/1/0182/2146/5664/files/post-types-blank.png?v=1779710493',
    },
  };

  const POST_TYPE_DESCRIPTIONS = {
    'Panel Only': 'Just the fence panel itself, supplied without any structural posts. Ideal if you are replacing an existing panel between currently installed posts, or if you are configuring a custom layout.',
    'End Post': 'The essential post for starting or finishing a run of fencing, with pre-routed holes on one side to connect your fence panel. This versatile post is also designed to be easily modified on-site by an installer for stepped applications on sloped terrain, ensuring a perfect finish.',
    'Line Post': 'The core component for creating a long, straight fence line. This post has pre-routed holes on opposite sides, allowing you to connect two fence panels and continue your run.',
    'Corner Post': 'The perfect solution for creating a clean, 90-degree turn in your fence line. This post has pre-routed holes on adjacent sides, ensuring a strong and seamless corner connection between two fence panels.',
    'T-Post': 'The specialist solution for creating a three-way, 90-degree junction in your fence line. This post is pre-routed on three sides, allowing you to securely connect three fence panels, perfect for dividing spaces or navigating complex layouts.',
    'Cross Post': 'The four-way cross post is pre-routed on all four sides, allowing you to connect four fence panels at a single intersecting junction. Ideal for complex layouts where two fence runs cross each other or for creating divided spaces with a central post.',
    'Blank Post': 'The ultimate solution for custom fencing projects. With no pre-routed holes, this versatile post is perfect for creating unique layouts or as a stand-alone post for a gate latch. It offers complete flexibility when standard posts don\'t meet your specific design needs.',
  };

  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function money(value) {
    const numeric = Number(value || 0);
    return MONEY_FORMATTER.format(Number.isFinite(numeric) ? numeric : 0);
  }

  function normaliseText(value) {
    return String(value || '').trim().toLowerCase().replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ');
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function capKeyFromLabel(label) {
    const value = normaliseText(label);
    if (!value || value.includes('no post cap') || value.includes('no cap')) return 'NO_CAP';
    if (value.includes('external') || value.includes('flat external')) return 'EXTERNAL_FLAT';
    if (value.includes('internal') || value.includes('flat internal')) return 'INTERNAL_FLAT';
    if (value.includes('gothic')) return 'GOTHIC';
    if (value.includes('new england') || value.includes('england')) return 'NEW_ENGLAND';
    return value.toUpperCase().replace(/[^A-Z0-9]+/g, '_');
  }

  function postTypeKey(label) {
    const value = normaliseText(label);
    if (value.includes('no post') || value.includes('panel only') || value === 'none') return 'NONE';
    if (value.includes('end')) return 'END';
    if (value.includes('line')) return 'LINE';
    if (value.includes('corner')) return 'CORNER';
    if (value.includes('t-post') || value === 't post' || value.includes('t post')) return 'T';
    if (value.includes('cross') || value.includes('x-post') || value.includes('4 way') || value.includes('four way')) return 'CROSS';
    if (value.includes('blank')) return 'BLANK';
    return value.toUpperCase().replace(/[^A-Z0-9]+/g, '_');
  }

  function findFieldsetByLegend(pattern) {
    const fieldsets = Array.from(document.querySelectorAll('variant-radios fieldset, .product-form__input--radios'));
    return fieldsets.find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      const subtitle = fieldset.querySelector('.subtitle');
      const text = (legend ? legend.textContent : '') + ' ' + (subtitle ? subtitle.textContent : '');
      return pattern.test(text);
    });
  }

  function getSelectedMainPostCapLabel() {
    const fieldset = findFieldsetByLegend(/post\s*caps?/i);
    if (!fieldset) return '';

    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    const select = fieldset.querySelector('select');
    if (select) return select.value;

    return '';
  }

  class SFPanelConfigurator {
    constructor(root) {
      this.root = root;
      this.ui = root.querySelector('[data-sf-panel-configurator-ui]');
      this.config = this.readConfig();
      this.productFormId = root.dataset.productFormId;
      this.productTitle = root.dataset.productTitle || '';

      if (!this.config || this.config.enabled === false) return;

      this.additionalPosts = asArray(
        this.config.additional_posts ||
        this.config.posts ||
        this.config.additionalPostVariants
      );
      this.postCaps = asArray(
        this.config.post_caps ||
        this.config.additional_post_caps ||
        this.config.cap_options
      );

      this.render();
      this.bind();
      this.autoSelectFirstVariants();
      this.syncFromMainCap();
      this.syncFromMainPost();
      this.updateMainPostDescription();
      this.update();

      this.root.sfPanelConfigurator = this;
    }

    readConfig() {
      const script = this.root.querySelector('[data-sf-panel-configurator-json]');
      if (!script) return null;

      try {
        const parsed = JSON.parse(script.textContent || 'null');
        if (typeof parsed === 'string') return JSON.parse(parsed);
        return parsed;
      } catch (error) {
        console.error('[SF Configurator] Invalid JSON metafield.', error);
        this.ui.innerHTML = '<div class="sf-panel-configurator__notice">Configurator JSON is invalid. Please check <code>custom.sf_panel_configurator</code>.</div>';
        return null;
      }
    }

    get labels() {
      return Object.assign({
        heading: 'Need an additional post?',
        addSecondPost: 'Optional: add a second post for this panel:',
        additionalPostType: 'Type of additional post required',
        additionalPostCap: 'Additional post cap',
        inheritCap: 'Use the same post cap style as selected above',
        changeCap: 'Choose a different cap for the additional post',
        yes: 'Yes',
        no: 'No',
      }, this.config.labels || {});
    }

    get optionImages() {
      return Object.assign({}, DEFAULT_OPTION_IMAGES, this.config.option_images || {});
    }

    findImage(group, label, key) {
      const maps = this.optionImages || {};
      const groupMap = maps[group] || {};
      const candidates = [
        label,
        key,
        capKeyFromLabel(label),
        postTypeKey(label),
      ].filter(Boolean);

      for (const candidate of candidates) {
        const raw = String(candidate);
        if (groupMap[raw]) return groupMap[raw];
        if (groupMap[raw.toUpperCase()]) return groupMap[raw.toUpperCase()];
        const normalised = normaliseText(raw);
        if (groupMap[normalised]) return groupMap[normalised];
      }

      return '';
    }

    render() {
      const labels = this.labels;
      const postOptions = this.additionalPosts.map((post, index) => {
        const label = post.label || post.title || post.post_type || `Post ${index + 1}`;
        const key = post.key || postTypeKey(label);
        const imageUrl = post.image || post.image_url || this.findImage('post_types', label, key);
        return this.radioMarkup({
          name: 'sf-extra-post-type',
          value: key,
          label,
          checked: index === 0,
          extraAttrs: post.variant_id ? '' : ' data-missing-variant="true"',
          imageUrl
        });
      }).join('');

      const capOptions = this.postCaps.map((cap, index) => {
        const label = cap.label || cap.title || `Cap ${index + 1}`;
        const key = cap.key || capKeyFromLabel(label);
        const imageUrl = cap.image || cap.image_url || this.findImage('post_caps', label, key);
        return this.radioMarkup({
          name: 'sf-extra-post-cap',
          value: key,
          label: label,
          checked: index === 0,
          imageUrl
        });
      }).join('');

      this.ui.innerHTML = `
        <div class="sf-panel-configurator__card">
          
          <div data-sf-add-second-fieldset style="margin-bottom: 24px;">
            <div class="product-group-name" style="margin-bottom: 8px;">
              <span class="subtitle" style="font-weight: 700; color: #000; font-size: 16px; text-transform: none;">
                ${labels.addSecondPost}
              </span>
            </div>
            <div class="sf-panel-configurator__options">
              ${this.radioMarkup({ name: 'sf-add-second-post', value: 'yes', label: labels.yes, checked: false })}
              ${this.radioMarkup({ name: 'sf-add-second-post', value: 'no', label: labels.no, checked: true })}
            </div>
          </div>

          <div class="sf-panel-configurator__extra-area is-hidden" data-sf-extra-area>
            
            <div class="sf-panel-configurator__instructions" data-sf-instructions>
              <h4 style="margin-top: 0; color: #3E3937; font-size: 14px;">How to Order Your Fence Run</h4>
              <p style="margin: 0 0 12px 0; color: #3E3937; font-size: 14px;">Most continuous fence lines require a mix of post types to connect the panels, plus <strong>one additional finishing post</strong> at the very end of the run.</p>
              
              <div style="background-color: #ffffff; border: 1px solid #e2e2e2; padding: 12px; border-radius: 4px;">
                <p style="margin: 0 0 8px 0; color: #3E3937; font-size: 14px; font-weight: 700;">Example: A straight run of 5 panels</p>
                <ol style="margin: 0; padding-left: 20px; color: #3E3937; line-height: 1.5; font-size: 14px;">
                  <li style="margin-bottom: 8px;">
                    <strong>The Ends:</strong> Select an <strong>End Post</strong> for the panel, choose <strong>“Yes”</strong> for the additional post (also an End Post), set quantity to <strong>1</strong>, and Add to Cart.
                  </li>
                  <li>
                    <strong>The Middle:</strong> Return to this page, select a <strong>Line Post</strong>, choose <strong>“No”</strong> for the additional post, enter your remaining panel quantity (<strong>4</strong>), and Add to Cart.
                  </li>
                </ol>
              </div>
            </div>

            <div data-sf-extra-post-fieldset style="margin-top: 24px; margin-bottom: 24px;">
              <div class="product-group-name" style="margin-bottom: 8px;">
                <span class="subtitle" style="font-weight: 700; color: #000; font-size: 16px; text-transform: none;">
                  ${labels.additionalPostType}
                </span>
              </div>
              <div class="sf-panel-configurator__options sf-native-image-option-group">
                ${postOptions}
              </div>
              <div class="sf-panel-configurator__description" data-sf-post-description></div>
            </div>

            <div data-sf-extra-cap-fieldset style="margin-bottom: 24px;">
              <div class="product-group-name" style="margin-bottom: 8px;">
                <span class="subtitle" style="font-weight: 700; color: #000; font-size: 16px; text-transform: none;">
                  ${labels.additionalPostCap}
                </span>
              </div>
              
              <label class="sf-panel-configurator__checkbox-row">
                <input type="checkbox" data-sf-inherit-cap checked>
                <span>${labels.inheritCap}</span>
              </label>

              <div class="sf-panel-configurator__cap-override is-hidden" data-sf-cap-override>
                <div style="margin-bottom: 10px; font-size: 14px; color: #3e3937;">${labels.changeCap}</div>
                <div class="sf-panel-configurator__options sf-native-image-option-group">
                  ${capOptions}
                </div>
              </div>
            </div>

            <div class="sf-panel-configurator__summary" data-sf-summary></div>
            <div class="sf-panel-configurator__error" data-sf-error hidden></div>
          </div>
        </div>
      `;
    }

    radioMarkup({ name, value, label, checked, extraAttrs = '', imageUrl = '' }) {
      const id = `${this.root.dataset.sectionId || 'sf'}-${name}-${value}`.replace(/[^a-zA-Z0-9_-]/g, '-');
      
      if (imageUrl) {
        return `
          <input type="radio" class="sf-hide-radio" id="${id}" name="${name}-${this.root.dataset.sectionId}" value="${this.escapeHtml(value)}" ${checked ? 'checked' : ''}${extraAttrs}>
          <label for="${id}" class="pills-variant-labels small-font sf-native-image-option" title="${this.escapeHtml(label)}">
            <span>${this.escapeHtml(label)}</span>
            <span class="sf-native-image-option__image-wrap">
              <img src="${this.escapeHtml(imageUrl)}" alt="${this.escapeHtml(label)}" width="60" height="60" fetchpriority="high" decoding="async">
            </span>
          </label>
        `;
      } else {
        return `
          <input type="radio" class="sf-hide-radio" id="${id}" name="${name}-${this.root.dataset.sectionId}" value="${this.escapeHtml(value)}" ${checked ? 'checked' : ''}${extraAttrs}>
          <label for="${id}" class="sf-text-pill">
            ${this.escapeHtml(label)}
          </label>
        `;
      }
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    bind() {
      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[data-sf-inherit-cap]')) {
          this.syncFromMainCap();
        }
        this.update();
      });

      document.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"], select')) {
          const fieldset = event.target.closest('fieldset') || event.target.closest('.product-form__input--radios');
          
          if (fieldset) {
            // Instant Client-Side Subtitle Text Update - Patched to prevent TypeError crashes
            const subtitle = fieldset.querySelector('.subtitle');
            if (subtitle) {
              const legendEl = fieldset.querySelector('legend');
              let groupNameRaw = (legendEl && legendEl.textContent) ? legendEl.textContent.trim() : '';
              
              // Clean up any existing colons in the legend text safely
              if (groupNameRaw.includes(':')) {
                groupNameRaw = groupNameRaw.split(':')[0].trim();
              }
              if (groupNameRaw) {
                subtitle.textContent = `${groupNameRaw}: ${event.target.value}`;
              }
            }

            const legend = fieldset.querySelector('legend');
            const subtitleText = fieldset.querySelector('.subtitle');
            const groupName = normaliseText((legend ? legend.textContent : '') + ' ' + (subtitleText ? subtitleText.textContent : ''));
            
            if (groupName.includes('fence post') || groupName.includes('post type')) {
              this.handleMainPostChange(event.target.value);
            }
          }

          this.syncFromMainCap();
          this.updateMainPostDescription();
          this.update();
        }
      });

      document.addEventListener('input', (event) => {
        if (event.target.matches('input[name="quantity"]')) {
          this.update();
        }
      });
    }

    autoSelectFirstVariants() {
      const fieldsets = Array.from(document.querySelectorAll('variant-radios fieldset, .product-form__input--radios'));
      let changed = false;

      fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) {
          const firstAvailable = fieldset.querySelector('input[type="radio"]:not(.disabled):not([disabled])') || fieldset.querySelector('input[type="radio"]');
          if (firstAvailable) {
            firstAvailable.checked = true;
            changed = true;
          }
        }
      });

      if (changed) {
        const firstChecked = document.querySelector('variant-radios input[type="radio"]:checked');
        if (firstChecked) {
          setTimeout(() => {
             firstChecked.dispatchEvent(new Event('change', { bubbles: true }));
          }, 0);
        }
      }
    }

    syncFromMainPost() {
      const fieldsets = Array.from(document.querySelectorAll('variant-radios fieldset, .product-form__input--radios'));
      const postFieldset = fieldsets.find((fs) => {
        const legend = fs.querySelector('legend');
        const subtitle = fs.querySelector('.subtitle');
        const text = normaliseText((legend ? legend.textContent : '') + ' ' + (subtitle ? subtitle.textContent : ''));
        return text.includes('fence post') || text.includes('post type');
      });

      if (postFieldset) {
        const checked = postFieldset.querySelector('input[type="radio"]:checked');
        if (checked) {
          this.handleMainPostChange(checked.value);
        } else {
          const select = postFieldset.querySelector('select');
          if (select) this.handleMainPostChange(select.value);
        }
      }
    }

    handleMainPostChange(postValue) {
      const normalisedPostValue = normaliseText(postValue);
      const isNoPost = normalisedPostValue.includes('no post') || normalisedPostValue.includes('panel only') || normalisedPostValue === 'none';

      // 1. Cap Auto-Select Logic
      const fieldsets = Array.from(document.querySelectorAll('variant-radios fieldset, .product-form__input--radios'));
      const capFieldset = fieldsets.find((fs) => {
        const legend = fs.querySelector('legend');
        const subtitle = fs.querySelector('.subtitle');
        const text = normaliseText((legend ? legend.textContent : '') + ' ' + (subtitle ? subtitle.textContent : ''));
        return text.includes('post cap');
      });

      if (capFieldset) {
        const capRadios = Array.from(capFieldset.querySelectorAll('input[type="radio"]'));

        if (isNoPost) {
          const noCapRadio = capRadios.find(r => normaliseText(r.value).includes('no post cap') || normaliseText(r.value).includes('no cap') || normaliseText(r.value) === 'none');
          if (noCapRadio && !noCapRadio.checked) {
             noCapRadio.checked = true;
             setTimeout(() => noCapRadio.dispatchEvent(new Event('change', { bubbles: true })), 0);
          }
        } else {
          const selectedCap = capFieldset.querySelector('input[type="radio"]:checked');
          if (selectedCap && (normaliseText(selectedCap.value).includes('no post cap') || normaliseText(selectedCap.value).includes('no cap') || normaliseText(selectedCap.value) === 'none')) {
             const firstRealCap = capRadios.find(r => !normaliseText(r.value).includes('no post cap') && !normaliseText(r.value).includes('no cap') && normaliseText(r.value) !== 'none' && !r.classList.contains('disabled') && !r.disabled);
             if (firstRealCap) {
               firstRealCap.checked = true;
               setTimeout(() => firstRealCap.dispatchEvent(new Event('change', { bubbles: true })), 0);
             }
          }
        }
      }

      // 2. Extra Post Yes/No Toggle Logic
      const yesRadio = this.root.querySelector('input[name^="sf-add-second-post"][value="yes"]');
      const noRadio = this.root.querySelector('input[name^="sf-add-second-post"][value="no"]');

      if (yesRadio && noRadio) {
        const yesLabel = this.root.querySelector(`label[for="${cssEscape(yesRadio.id)}"]`);
        
        if (isNoPost) {
          noRadio.checked = true;
          yesRadio.disabled = true;
          if (yesLabel) {
            yesLabel.style.opacity = '0.4';
            yesLabel.style.cursor = 'not-allowed';
            yesLabel.style.textDecoration = 'line-through';
          }
          this.update();
        } else {
          yesRadio.disabled = false;
          if (yesLabel) {
            yesLabel.style.opacity = '1';
            yesLabel.style.cursor = 'pointer';
            yesLabel.style.textDecoration = 'none';
          }
        }
      }
    }

    getMainQuantity() {
      const form = this.productFormId ? document.getElementById(this.productFormId) : null;
      const input = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');
      const value = input ? Number(input.value || 1) : 1;
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    updateMainPostDescription() {
      const fieldsets = Array.from(document.querySelectorAll('variant-radios fieldset, .product-form__input--radios'));
      const postFieldset = fieldsets.find((fs) => {
        const legend = fs.querySelector('legend');
        const subtitle = fs.querySelector('.subtitle');
        const text = (legend ? legend.textContent : '') + ' ' + (subtitle ? subtitle.textContent : '');
        return normaliseText(text).includes('fence post') || normaliseText(text).includes('post type');
      });

      if (!postFieldset) return;

      const checked = postFieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const label = checked.value;
      const descriptions = Object.assign({}, POST_TYPE_DESCRIPTIONS, this.config.post_type_descriptions || {});
      const descText = descriptions[label] || descriptions[label.replace(/-/g, ' ')] || '';

      let descContainer = postFieldset.querySelector('.sf-main-post-description');
      if (!descContainer) {
        descContainer = document.createElement('div');
        descContainer.className = 'sf-main-post-description';
        postFieldset.appendChild(descContainer);
      }

      if (descText) {
        descContainer.innerHTML = `<strong>${this.escapeHtml(label)}:</strong> ${descText}`;
        descContainer.style.display = 'block';
      } else {
        descContainer.style.display = 'none';
      }
    }

    update() {
      const extraArea = this.root.querySelector('[data-sf-extra-area]');
      const addSecond = this.shouldAddSecondPost();
      if (extraArea) extraArea.classList.toggle('is-hidden', !addSecond);

      const capOverride = this.root.querySelector('[data-sf-cap-override]');
      const inheritCap = this.shouldInheritCap();
      if (capOverride) capOverride.classList.toggle('is-hidden', inheritCap);

      this.updatePostDescription();
      this.updateSummary();
      this.clearError();
    }

    shouldAddSecondPost() {
      const selected = this.root.querySelector('input[name^="sf-add-second-post"]:checked');
      return selected && selected.value === 'yes';
    }

    shouldInheritCap() {
      const input = this.root.querySelector('[data-sf-inherit-cap]');
      return Boolean(input && input.checked);
    }

    getSelectedPost() {
      const selected = this.root.querySelector('input[name^="sf-extra-post-type"]:checked');
      if (!selected) return null;
      return this.additionalPosts.find((post) => (post.key || postTypeKey(post.label || post.title)) === selected.value) || null;
    }

    getSelectedCap() {
      if (this.shouldInheritCap()) {
        const inheritedKey = capKeyFromLabel(getSelectedMainPostCapLabel());
        return this.postCaps.find((cap) => (cap.key || capKeyFromLabel(cap.label || cap.title)) === inheritedKey)
          || this.postCaps.find((cap) => (cap.key || capKeyFromLabel(cap.label || cap.title)) === 'NO_CAP')
          || null;
      }

      const selected = this.root.querySelector('input[name^="sf-extra-post-cap"]:checked');
      if (!selected) return null;
      return this.postCaps.find((cap) => (cap.key || capKeyFromLabel(cap.label || cap.title)) === selected.value) || null;
    }

    syncFromMainCap() {
      if (!this.shouldInheritCap()) return;
      const inheritedKey = capKeyFromLabel(getSelectedMainPostCapLabel());
      const input = this.root.querySelector(`input[name^="sf-extra-post-cap"][value="${inheritedKey}"]`);
      if (input) input.checked = true;
    }

    updatePostDescription() {
      const target = this.root.querySelector('[data-sf-post-description]');
      if (!target) return;
      
      const post = this.getSelectedPost();
      let newHTML = '';
      
      if (post) {
        const label = post.label || post.title || '';
        const descriptions = Object.assign({}, POST_TYPE_DESCRIPTIONS, this.config.post_type_descriptions || {});
        const descText = post.description || descriptions[label] || descriptions[label.replace('-', ' ')] || '';
        const priceText = post.price !== undefined && post.price > 0 ? ` <span style="color: #016534;">(+${money(post.price)})</span>` : '';
        
        if (descText) {
          newHTML = `<strong>${this.escapeHtml(label)}${priceText}:</strong> ${descText}`;
        }
      }

      if (target.innerHTML !== newHTML) {
        const currentHeight = target.offsetHeight;
        target.style.height = currentHeight + 'px';
        target.style.opacity = '0';
        
        setTimeout(() => {
          target.innerHTML = newHTML;
          target.style.display = newHTML ? 'block' : 'none';
          
          if (newHTML) {
             target.style.height = 'auto';
             const newHeight = target.offsetHeight;
             target.style.height = currentHeight + 'px';
             target.offsetHeight; 
             target.style.height = newHeight + 'px';
             target.style.opacity = '1';
             setTimeout(() => {
               target.style.height = 'auto';
             }, 300);
          }
        }, 200); 
      }
    }

    updateSummary() {
      const target = this.root.querySelector('[data-sf-summary]');
      if (!target) return;

      if (!this.shouldAddSecondPost()) {
        target.innerHTML = '';
        return;
      }

      const post = this.getSelectedPost();
      const cap = this.getSelectedCap();
      
      const postLabel = post ? this.escapeHtml(post.label || post.title) : 'Additional post';
      const postPrice = post && post.price !== undefined && post.price > 0 ? money(post.price) + ' each' : '';

      const capLabel = cap ? this.escapeHtml(cap.label || cap.title) : 'No Post Cap';
      const capPrice = cap && cap.price !== undefined && cap.price > 0 ? money(cap.price) + ' each' : '';

      let html = `Additional item: <strong>${postLabel}</strong> &times; 1`;
      if (postPrice) html += ` <span class="sf-panel-configurator__muted">${postPrice}</span>`;
      
      html += `<br>Additional post cap: <strong>${capLabel}</strong> &times; 1`;
      if (capPrice) html += ` <span class="sf-panel-configurator__muted">${capPrice}</span>`;

      target.innerHTML = html;
    }

    setError(message) {
      const target = this.root.querySelector('[data-sf-error]');
      if (!target) return;
      target.textContent = message;
      target.hidden = false;
    }

    clearError() {
      const target = this.root.querySelector('[data-sf-error]');
      if (!target) return;
      target.textContent = '';
      target.hidden = true;
    }

    buildCartPayload(formData) {
      if (!this.shouldAddSecondPost()) return null;

      const post = this.getSelectedPost();
      if (!post) throw new Error('Please select a valid additional post.');

      const postId = Number(post.variant_id);
      if (!postId || isNaN(postId)) {
        throw new Error(
          `Cannot add to basket: The Variant ID for the selected post is missing or invalid. ` +
          `sku=${post.sku || 'unknown'} — run scripts/patch_configurator_post_skus.py to refresh from the masters.`
        );
      }

      const cap = this.getSelectedCap();
      const capKey = cap ? (cap.key || capKeyFromLabel(cap.label || '')) : 'NO_CAP';

      const items = [
        {
          id: postId,
          quantity: 1 
        }
      ];

      if (cap && capKey !== 'NO_CAP') {
        const capId = Number(cap.variant_id);
        if (!capId || isNaN(capId)) {
          throw new Error(
            `Cannot add to basket: The Variant ID for the selected cap is missing or invalid. ` +
            `sku=${cap.sku || 'unknown'}`
          );
        }
        
        items.push({
          id: capId,
          quantity: 1
        });
      }

      const mainProperties = {};

      return { items, mainProperties };
    }
  }

  function init() {
    document.querySelectorAll('[data-sf-panel-configurator]').forEach((root) => {
      if (!root.sfPanelConfigurator) new SFPanelConfigurator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();